import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Etc({ receipt }:Props) {
    const { t } = useTranslation('orderReceipt');
    const {
        order, cardNo, cardName, approvalNo,
    } = receipt;
    const { orderNo, paymentAmount } = order;
    return (
        <Column fullWidth>
            <Column fullWidth>
                {/*
                <Row fullWidth justify='space-between'>
                    <Text>결제(컵보증금 포함)</Text>
                    <Text>7,000</Text>
                </Row>
                */}
                <Row fullWidth justify='space-between'>
                    <Text>{t('etc.orderNumber')}</Text>
                    <Text>{orderNo}</Text>
                </Row>
            </Column>

            {/*
            <Row fullWidth justify='space-between'>
                <Text>선불카드</Text>
                <Text>3,000</Text>
            </Row>
            */}
            {/*
            <ReceiptDivider/>
            <Row fullWidth justify='space-between'>
                <Text>선물쿠폰</Text>
                <Text>신규가입 쿠폰</Text>
            </Row>
            <ReceiptDivider/>
            */}
            {paymentAmount !== 0 && (
                <Fragment>
                    <ReceiptDivider/>
                    <Column fullWidth spacing={0.5}>
                        {cardName && (
                            <Row fullWidth justify='space-between'>
                                <Text>{t('etc.cardType')}</Text>
                                <Text>{cardName}</Text>
                            </Row>
                        )}
                        {cardNo && (
                            <Row fullWidth justify='space-between'>
                                <Text>{t('etc.cardNumber')}</Text>
                                <Text>{cardNo}</Text>
                            </Row>
                        )}
                        {approvalNo && (
                            <Row fullWidth justify='space-between'>
                                <Text>{t('etc.approvalNumber')}</Text>
                                <Text>{approvalNo}</Text>
                            </Row>
                        )}
                    </Column>
                </Fragment>
            )}
        </Column>
    );
}

export default Etc;
